import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionCleanupService } from '../../core/services/session-cleanup.service';

/**
 * Whether the notifications drawer is open.
 *
 * Kept in a service rather than in the app bar so that the drawer can live at the top of the layout,
 * where it can be full height, while the button that opens it stays in the bar.
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationsDrawerService {
  private _isOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isOpen$: Observable<boolean> = this._isOpen$.asObservable();

  constructor(sessionCleanupService: SessionCleanupService) {
    // A drawer left open would show the next user an empty or stale panel.
    sessionCleanupService.ended$.subscribe(() => this.close());
  }

  public get isOpen(): boolean {
    return this._isOpen$.value;
  }

  public open(): void {
    this._isOpen$.next(true);
  }

  public close(): void {
    this._isOpen$.next(false);
  }

  public toggle(): void {
    this._isOpen$.next(!this._isOpen$.value);
  }
}
